'use strict';

import angular from 'angular';
import End from './end.controller';

export default angular.module('bfastCaptureManagerApp.application.end', [])
  .controller('AppEndController', End)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/end/index.js